import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

const HandleClickOutside = ({ handle, children, className }) => {
  const ref = useRef(null);
  const handleClick = event => {
    if (ref && !ref.current.contains(event.target)) handle();
  };
  useEffect(() => {
    document.addEventListener('click', handleClick);
    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, []);
  return (
    <div className={ className } ref={ ref }>{ children }</div>
  );
};

HandleClickOutside.propTypes = {
  handle: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  className: PropTypes.string
};

export default HandleClickOutside;
